<template>
  <v-dialog ref="dialog" v-model="modal" :return-value.sync="time" persistent width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field dense v-model="time" :label="label" prepend-icon="access_time" readonly v-on="on"
      :error-messages="errorMessages"></v-text-field>
    </template>
    <v-time-picker v-if="modal" v-model="time" full-width format="24hr">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
      <v-btn text color="primary" @click="$refs.dialog.save(time)">OK</v-btn>
    </v-time-picker>
  </v-dialog>
</template>

<script>
export default {
  props: ["value", "label",'errorMessages'],
  data() {
    return {
      modal: false
    };
  },
  computed: {
    time: {
      get: function() {
        return this.value;
      },
      set: function(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>